import React from "react";
import { Link } from "react-router-dom";

import { Collapse, Card, CardBody, Input, Label } from "reactstrap";

// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";

interface ImageCaptureProps {
  images: { blobUrl: string; file: File; index: number }[];
  onRemoveImage : (index:number) => void;
  // isOpen: boolean;
  // onSelectImages: (images: Array<any>) => void;
  // onToggle: () => any;
  // onSelectFiles: (files: Array<any>) => void;
}
const ImageCapture = ({
  // isOpen,
  // onSelectImages,
  // onToggle,
  // onSelectFiles,
  images, onRemoveImage
}: ImageCaptureProps) => {
  const isOpen = images && images.length > 0;
  return (
    <Collapse
      isOpen={isOpen}
      className="chat-input-collapse"
      id="chatinputmorecollapse"
    >
      <Card className="mb-0">
        <CardBody className="p-2" style={{ display: 'flex', flexWrap: 'wrap' }}>

          {images.map((image) => (
            <div key={image.index} style={{ position: "relative", padding:"5px" }}>
              <img
                className="img-capture-preview"
                src={image.blobUrl}
                alt={`Pasted ${image.index}`}
              />
              <button className="img-capture-preview-x" onClick={()=>onRemoveImage(image.index)}>X</button>
            </div>
          ))}
          {/* <img className="img-capture-preview" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmpa-OPGCHyX-GPQRrwoR289o79lh94R-ERw&s"/>
        <img className="img-capture-preview" src="https://images.rawpixel.com/image_800/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIzLTAzL3JtNTk3ZGVzaWduLWMtc2F2ZS0wMDIuanBn.jpg"></img> */}

        </CardBody>
      </Card>
    </Collapse>
  );
};

export default ImageCapture;
